import { ValidatorFn } from '@angular/forms/src/directives/validators';
import { Validation } from '../validation.interface';
import { Validators } from '@angular/forms';

export class EmailModel implements Validation {
  static EMAIL = 'email';

  getValidatorsName(): string {
    return EmailModel.EMAIL;
  }
  getValidatorsErrorDescription(): string {
    return 'E-mail inválido';
  }
  getValidatorsRule(): ValidatorFn {
    return Validators.email;
  }
}



// WEBPACK FOOTER //
// /usr/src/app/src/app/components/input/rules/implementations/email.model.ts